<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <PersonalLoanLogin />
    <!-- <policyquote /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import PersonalLoanLogin from "@/components/personal-loan-login.vue";
//import policyquote from "@/views/policy-quote.vue";

export default {
  name: 'Home',
  components: {
    PersonalLoanLogin
    //policyquote
  }
}
</script>
